import { createSelector } from 'reselect';
import { getBusinessDetails } from '@/selectors/merchant';

export const getDefaultState = createSelector(
  getBusinessDetails,
  ({
    registered = undefined,
    registrationId = '',
    organizationRegistrationAuthority = '',
    organizationEntityType,
  }) => ({
    toggleValue: registered,
    organizationEntityType,
    registrationNumber: registrationId,
    registrationCourt: organizationRegistrationAuthority,
  }),
);
